import React, { useEffect, useState } from 'react';
import ToolBar from '../../../components/ToolBar';
import { useNavigate } from 'react-router-dom';
import AsteriskForm from './components/AsteriskForm';
import CheckForm from './components/CheckForm';
import { Tabs } from 'antd';
import SendAsteriskForm from './components/SendAsteriskForm';
import { AppDispatch } from '../../../store/app';
import { useDispatch } from 'react-redux';
import { getAsteriskNumberList } from '../../../store/NumberManagementSlice';
import ListTable from './components/ListTable';
import { CONSTANT } from '../../../config/Constant';

const AsteriskNumber: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<string>('1');
  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [paginationData, setPaginationData] = useState<any>({
    current: 1,
    page_size: 10,
  });

  const getList = (data?: any) => {
    if (activeTab === '4') {
      setTableLoading(true);
      const payload = {
        ...data,
        current: data?.current ?? paginationData?.current ?? 1,
        page_size: data?.page_size ?? paginationData?.page_size ?? 10,
        // user_id: '661e722d74bca72daa7d1a3b',
      };
      dispatch(getAsteriskNumberList(payload))
        .then((res: any) => {
          setListData(res?.data?.data);
          setTotalData(res?.data?.total_data);
          setTableLoading(false);
        })
        .catch(() => {
          setListData([]);
          setTotalData(0)
          setTableLoading(false);
        });
    }
  };

  const token = localStorage.getItem('token');
  useEffect(() => {
    if (token && token !== 'undefined') {
      getList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const runWebSocket = (ws: any) => {
    ws.onopen = function () {
      console.log('WebSocket connection established');
    };

    ws.onclose = function () {
      console.log('WebSocket connection closed');
    };

    ws.onmessage = function (event) {
      const eventData = JSON.parse(event.data);

      const token = localStorage.getItem('token');
      if (token === null) {
        navigate('/login');
      }

      const getNumber = eventData?.user_id;
      // setDataViewDrawer({ number: getNumber });

      if (getNumber) {
        // setApiResponse(getNumber);
        getList();
      } else {
        ws.close();
      }
    };
  };
  useEffect(() => {
    const ws = new WebSocket(CONSTANT.WS_URL);
    runWebSocket(ws);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ToolBar title={'Asterisk Number'} />
      <Tabs
        defaultActiveKey="1"
        type="card"
        size="large"
        onChange={(key: string) => setActiveTab(key)}
        destroyInactiveTabPane={true}
        items={[
          {
            key: '1',
            label: 'Add Asterisk Number',
            children: <AsteriskForm mode="add" />,
          },
          {
            key: '2',
            label: 'Update Asterisk Number',
            children: <AsteriskForm mode="update" />,
          },
          {
            key: '3',
            label: 'Check Asterisk Number',
            children: <CheckForm />,
          },
          {
            key: '4',
            label: 'Send Asterisk Number',
            children: <SendAsteriskForm getList={getList} />,
          },
        ]}
      />
      {activeTab === '4' && (
        <ListTable
          listData={listData}
          setListData={setListData}
          tableloading={tableloading}
          getList={getList}
          totalData={totalData}
          setTableLoading={setTableLoading}
          paginationData={paginationData}
          setPaginationData={setPaginationData}
        />
      )}
    </>
  );
};

export default AsteriskNumber;
